import { useQuery } from '@tanstack/react-query';
import type { PaginatedProjectsDto, ListProjectsQuery } from '@cutlyft/zod-schemas';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface ProjectsApiResponse {
  success: boolean;
  data: PaginatedProjectsDto;
}

/**
 * Hook to fetch the paginated project list for the current tenant.
 * Calls GET /projects with optional search/status/pagination filters.
 */
export function useProjects(query?: Partial<ListProjectsQuery>) {
  return useQuery({
    queryKey: queryKeys.projects.list(query),
    queryFn: async () => {
      const response = await apiClient.get<ProjectsApiResponse>('/projects', { params: query });
      return response.data.data;
    },
  });
}
